import React from 'react';
import { portfolioData } from '../../data/portfolioData';
// Import your image correctly
import profileImage from '../../assets/images/me.jpg';
import './Hero.css';

const Hero = () => {
  const { personalInfo } = portfolioData;

  // Function to handle CV download
  const handleDownloadCV = () => {
    const link = document.createElement('a');
    link.href = '/cv/PM-Khumalo-CV.pdf';
    link.download = 'PM-Khumalo-CV.pdf';
    link.click();
  };

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>{personalInfo.name}</h1>
            <h2>{personalInfo.title}</h2>
            <p>Full-stack developer specializing in Flutter, Spring Boot, and cloud technologies. Passionate about building efficient, scalable solutions with modern tech stacks.</p>
            <div className="hero-buttons">
              <a href="#projects" className="btn">
                <i className="fas fa-briefcase icon-spacing"></i>
                <span>View My Work</span>
              </a>
              <a href="#contact" className="btn btn-outline">
                <i className="fas fa-paper-plane icon-spacing"></i>
                <span>Get In Touch</span>
              </a>
              <button onClick={handleDownloadCV} className="btn btn-secondary">
                <i className="fas fa-download icon-spacing"></i>
                <span>Download CV</span>
              </button>
            </div>
            <div className="social-links">
              <a 
                href={personalInfo.linkedin} 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="LinkedIn"
                className="social-link"
                data-tooltip="LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a 
                href={personalInfo.github} 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="GitHub"
                className="social-link"
                data-tooltip="GitHub"
              >
                <i className="fab fa-github"></i>
              </a>
              <a 
                href={`mailto:${personalInfo.email}`} 
                aria-label="Email"
                className="social-link"
                data-tooltip="Email"
              >
                <i className="fas fa-envelope"></i>
              </a>
              <a 
                href={`tel:${personalInfo.phone}`} 
                aria-label="Phone"
                className="social-link"
                data-tooltip="Call Me"
              >
                <i className="fas fa-phone"></i>
              </a>
            </div>
          </div>
          <div className="hero-image">
            <div className="profile-image-container">
              <img 
                src={profileImage} 
                alt="PM Khumalo"
                className="profile-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  document.querySelector('.image-placeholder').style.display = 'flex';
                }}
              />
              <div className="image-placeholder" style={{display: 'none'}}>
                <i className="fas fa-user"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;